import { AppHTTPService } from '../http-service'

export const getEnvironmentLogs = async (params: any): Promise<any> => {
  return AppHTTPService.axios.get(`/v1/agents/executions`, { params }).then((res) => {
    const mutated = res.data.data.map((log: any) => {
      return {
        ...log,
        id: `${log.eventId}:${log.id}`,
        logId: log.id,
        eventId: log.eventId,
      }
    })
    return { data: mutated, pagination: res.data.pagination }
  })
}

export const getAgentLogs = async (params: { environmentId: string; agentId: string }): Promise<any> => {
  return AppHTTPService.axios
    .get(`/v1/agents/${params.agentId}/logs`, { params: { environmentId: params.environmentId } })
    .then((res) => {
      const { data: logsData, pagination } = res.data
      const mutated = logsData.map((log: any) => {
        return {
          ...log,
          id: log.eventId,
          logId: log.id,
        }
      })
      return { data: mutated, pagination }
    })
}

export const getLogByCompoundKey = async (compoundKey: string): Promise<any> => {
  const eventId = compoundKey.split(':')[0]
  return AppHTTPService.axios.get(`/v1/agents/log/${eventId}`).then((res) => {
    return res.data
  })
}
